module.exports = __webpack_public_path__ + "img/Icon.091b1adb.svg";